<h2 mat-dialog-title>
  {{
    "customerSelection.title." +
      (multi ? "multi." : "single.") +
      ((isFamily$ | async) === true ? "people" : "customers") | translate
  }}
</h2>
<mat-dialog-content>
  <ca-customer-selection-view
    paginationId="customerSelectDialogComponent"
    [hideUnassigned]="hideUnassigned"
    [selectedIds]="selectedIds"
    [selectedCustomerListIds]="selectedCustomerListIds"
    [disableNoMedia]="disableNoMedia"
    [disableWhereFamilyRole]="disableWhereFamilyRole"
    (customerSelected)="toggle($event)"
    (customerListSelected)="toggleCustomerList($event)"
    [initialTab]="data.initialTab"
    [multiple]="multi"
  >
  </ca-customer-selection-view>
</mat-dialog-content>

<mat-dialog-actions class="flex flex-row-reverse align-end items-baseline">
  <button
    *ngIf="selectedIds | customersFromIds | async as selectedCustomerEntities"
    mat-button
    (click)="submitAndClose(selectedCustomerEntities)"
  >
    Done
  </button>

  <mat-accordion *ngIf="multi" class="flex justify-start w-11/12">
    <mat-expansion-panel
      class="mat-elevation-z0"
      [expanded]="selectedIdPanelOpenState"
      (opened)="selectedIdPanelOpenState = true"
      (closed)="selectedIdPanelOpenState = false"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <p class="panelTitle">
            {{
              "customerSelection.selectedCount." +
                ((isFamily$ | async) === true ? "people" : "customers")
                | translate : { count: selectedIds.length }
            }}
          </p>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-chip-list
        [aria-label]="
          (isFamily$ | async) === true
            ? 'Selected People'
            : 'Selected Customers'
        "
        [multiple]="false"
        class="chipSelection"
      >
        <mat-chip
          class="selectedCustomerChip"
          color="secondary"
          *ngFor="
            let customer of selectedIds
              | customersFromIds
              | async
              | filter
                : customerFilter(
                    disableNoMedia ? true : null,
                    disableWhereFamilyRole ? true : null
                  )
          "
          (click)="toggle(customer)"
        >
          <div class="selectedCustomerChipAvatar">
            <ca-avatar
              [chip]="true"
              [fullName]="customer | displayname"
              [image]="
                customer.profileImage != null
                  ? (customer.profileImage
                    | filedownloadurl : 'sizeTiny'
                    | async)
                  : null
              "
              [blur]="
                customer.profileImage != null
                  ? (customer.profileImage | mediaBlurUrl)
                  : null
              "
            >
            </ca-avatar>
          </div>
          <span class="noSelect">
            {{ customer | displayname }}
          </span>
          <mat-icon>close</mat-icon>
        </mat-chip>
      </mat-chip-list>

      <mat-chip-list
        *ngIf="disableNoMedia"
        [aria-label]="
          (isFamily$ | async) === true
            ? 'Selected people without media enabled'
            : 'Selected customers without media enabled'
        "
        [multiple]="false"
      >
        <mat-chip
          class="selectedCustomerChipNoMedia"
          color="disabled"
          [matTooltip]="'customerList.customerPhotosBlocked.noName' | translate"
          *ngFor="
            let customer of selectedIds
              | customersFromIds
              | async
              | filter : customerFilter(false)
          "
          (click)="toggle(customer)"
        >
          <div class="selectedCustomerChipAvatar disabledChipAvatar">
            <ca-avatar
              [chip]="true"
              [fullName]="customer | displayname"
              [image]="
                customer.profileImage != null
                  ? (customer.profileImage
                    | filedownloadurl : 'sizeTiny'
                    | async)
                  : null
              "
              [blur]="
                customer.profileImage != null
                  ? (customer.profileImage | mediaBlurUrl)
                  : null
              "
            >
            </ca-avatar>
          </div>
          <span class="noSelect">
            {{ customer | displayname }}
          </span>
          <mat-icon>no_photography</mat-icon>
        </mat-chip>
      </mat-chip-list>
    </mat-expansion-panel>
  </mat-accordion>
</mat-dialog-actions>
